export default __webpack_public_path__ + "static/media/Flag of Niue.5327192b.gif";